import { Layout } from 'antd'
import { Outlet } from 'react-router-dom'
import LeftNavigationPanel from 'src/app/shared/components/layout/left-navigation-panel'
import AppHeader from '../header/app-header'

const AppLayout: React.FC = () => {
  return (
    <Layout>
      <LeftNavigationPanel />
      <Layout>
        <AppHeader />
        <Outlet />
      </Layout>
    </Layout>
  )
}

export default AppLayout
